import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  bar: {
    backgroundColor: "#ffffff"
  },
  logo: {
    marginRight: theme.spacing(1),
    color: "green"
  },
  title: {
    flexGrow: 1,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen"',
    fontWeight: 400
  },
  username: {
    flexGrow: 1,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen"',
    fontWeight: 400,
    display: "inline-block"
  },
  img: {
    height: "24px",
    cursor : "pointer"
  },
  noTextTransformLabel : {
    textTransform : "none"
  }
}));

export default useStyles;
